import { render, staticRenderFns } from "./BlockSpinner.vue?vue&type=template&id=3ade9de8&scoped=true&"
import script from "./BlockSpinner.vue?vue&type=script&lang=js&"
export * from "./BlockSpinner.vue?vue&type=script&lang=js&"
import style0 from "./BlockSpinner.vue?vue&type=style&index=0&id=3ade9de8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ade9de8",
  null
  
)

export default component.exports